import type {PS} from '@wix/document-services-types'
import getAppStudioData from './getAppStudioData'

const isAppStudio = (ps: PS) => getAppStudioData(ps) !== undefined

export default isAppStudio
